import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, useEffect } from "react";

const Loader=()=>{
    
    return(
        <div className="d-flex justify-content-center" style={{display:'flex',flexDirection:'column',width:'100%',justifyContent:'center',alignSelf:'center'}}>
            <div className="spinner-border" role="status" style={{alignSelf:'center',width:'100px',height:'100px',color:'#1d3e93'}}>
            </div>
            <span className="sr-only" style={{alignSelf:'center',padding:10,color:'#1d3e93'}}>Processing Please Wait</span>
            
        </div>
    )
}

export default Loader